// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-countdown[data-v-3fddc394]{height:32px;padding:0 4px;min-width:58px;border-radius:4px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;display:flex;align-items:center;justify-content:center;color:#fff;font-size:20px;font-weight:400;line-height:32px;background-color:#feb546;font-feature-settings:\"tnum\";font-variant-numeric:tabular-nums;.icon-clock{margin-right:8px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
